
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13","r":"12.5","stroke":"#50657c"}}),_c('path',{attrs:{"d":"M13 7.592l1.12 3.377.16.55h4.24l-2.96 2.12-.48.314.16.55 1.12 3.377-2.88-2.042-.48-.393-.48.393-2.96 2.12 1.12-3.377.16-.55-.48-.314-2.88-2.199h4.24l.16-.55L13 7.593zM13 5l-1.92 5.733H5l4.96 3.534L8.04 20 13 16.466 17.96 20l-1.92-5.733L21 10.733h-6.08L13 5z","fill":"#50657c"}})])
          )
        }
      }
    